export default __webpack_public_path__ + "static/media/galleryimg1.60fd888b.jpg";